<template>
  <AppModal>
    <template slot="header">
      <div class="d-flex justify-space-between pt-3 pl-3 w-full">
        <div class="modal-title font-weight-bold" role="alert">
          <span v-if="isEnableModal">Enable</span>
          <span v-else class="red--text">Disable</span>
          document upload for this application?
        </div>
        <v-icon
          class="closeBtn"
          aria-label="close"
          @click="$emit('close')"
          data-testid="close-icon"
        >
          mdi-close
        </v-icon>
      </div>
    </template>
    <template slot="body">
      <div v-if="isEnableModal" class="content mt-3 mx-3">
        <p>
          An alert will be displayed on the Ehub dashboard guiding the
          parent/carer through uploading their additional documents.
        </p>
        <div class="info-container px-6 py-6">
          <p>
            Please contact the parent/carer, specify the documents you require
            of them, and instruct them to go to Online Enrolment to upload them.
          </p>
          <span class="d-flex">
            <v-icon class="icon"> mdi-content-copy </v-icon>
            <button
              class="ml-2 pt-4 font-weight-bold hyperlink"
              type="button"
              data-testid="copy-link-clipboard"
              @click="copyLinkToClipboard"
            >
              Copy Online Enrolment link to clipboard
            </button>
          </span>
        </div>
      </div>
      <div v-else class="content mt-3 mx-3">
        The parent/carer will no longer have access to upload additional
        documents through the Ehub dashboard.
      </div>
    </template>
    <template #footer>
      <div class="mb-0 mr-3 pb-2">
        <AdsButton
          v-if="isEnableModal"
          icon="mdi-upload-outline"
          button-text="Enable document upload"
          aria-label="Enable document upload"
          data-testid="btn-enable"
          @click="confirmToggleDocUploadStatus(true)"
        />
        <AdsButton
          v-else
          class="red"
          icon="mdi-upload-lock-outline"
          button-text="Disable document upload"
          aria-label="Disable document upload"
          data-testid="btn-disable"
          @click="confirmToggleDocUploadStatus(false)"
        />
        <AdsButton
          tertiary
          button-text="Cancel"
          aria-label="Cancel"
          @click="$emit('close')"
          data-testid="btn-cancel"
        />
      </div>
    </template>
  </AppModal>
</template>
<script>
import AppModal from '@/components/app/AppModal.vue'
import { AdsButton } from '@nswdoe/doe-ui-core'
import { mapGetters } from 'vuex'

export default {
  name: 'DocsUploadToggleStatusModal',
  props: {
    type: {
      type: String,
      default: 'enable'
    }
  },
  components: {
    AppModal,
    AdsButton
  },
  computed: {
    ...mapGetters(['oesProperties']),
    isEnableModal() {
      return this.type === 'enable'
    }
  },
  methods: {
    copyLinkToClipboard() {
      navigator.clipboard.writeText(process.env.VUE_APP_EHUB_LINK)
    },
    confirmToggleDocUploadStatus(status) {
      this.$store.dispatch('saveToggleDocUploadStatus', status).finally(() => {
        this.$emit('close')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.w-full {
  width: 100%;
  .modal-title {
    color: $color-primary;
  }
}
.theme--light.v-icon.v-icon--link:focus {
  border: none !important;
  outline: 3px solid currentColor;
}
::v-deep .info-container {
  background-color: $ads-light-10;
  border-radius: 4px;
  .icon {
    color: $grey-1;
  }
  .hyperlink {
    color: $grey-1;
    text-decoration: underline;
    text-decoration-skip-ink: none;
    border: none;
    padding: 0px !important;
  }
}
</style>
